import { baseUrl } from "util/APIBaseUrl";
import getRequest from "util/APIHelperGet";
import postRequest from "util/APIHelperPost";
import putRequest from "util/APIHelperPut";

export const getBanksList = async () => {
  const response = await getRequest(`${baseUrl}/banks`);
  return response;
};

export const getEmployeeBankDetails = async (employeeId) => {
  const response = await getRequest(`${baseUrl}/v2/employee/${employeeId}`);
  return response;
};

export const addEmployeeBankDetails = async (employeeId, data) => {
  const response = await postRequest(`${baseUrl}/employee/${employeeId}/bank-details`, JSON.stringify(data));
  if (response?.payload?.error) {
    throw new Error(response.payload.error[0]?.description || "Failed to add bank details");
  }
  return response;
};

export const updateEmployeeBankDetails = async (employeeId, bankDetailId, data) => {
  const response = await putRequest({
    path: `/employee/${employeeId}/bank-details/${bankDetailId}`,
    body: data,
    stringifyBody: true,
  });
  if (response?.payload?.error) {
    throw new Error(response.payload.error[0]?.description || "Failed to update bank details");
  }
  return response;
};
